export default __webpack_public_path__ + "static/services-a4fee4d1733fbe6618316a3ed56b4514.mp4";